import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import logger from 'es6/redux/middleware/logger';
import env from 'es6/redux/modules/env';

export const reducers = combineReducers({ env });

export const middleware = [logger, thunk];

export default () => createStore(reducers, applyMiddleware(...middleware));
